










































import { Component, Vue } from "vue-property-decorator";

@Component
export default class extends Vue {
  cards = ["Today", "Yesterday"];
  drawer = null;
  items = [
    { text: "Machine", icon: "mdi-robot", to: "/" },
    { text: "Materials", icon: "mdi-cube", to: "/materials" },
    { text: "Cutters", icon: "mdi-saw-blade", to: "/cutters" },
    { text: "Calculator", icon: "mdi-calculator", to: "/calculator" },
    { text: "Optimization", icon: "mdi-repeat-variant", to: "/optimization" },
    { text: "Settings", icon: "mdi-cog", to: "/settings" },
  ];
  selectedItem = "";
}
